/* Cape Mohair funnel script. Built by 04-funnel/shopify/build-shopify-theme.py from cm-funnel-shopify.js. */
var CM = (function () {
  var PREFIX = "cm_";

  function get(key) {
    try { return JSON.parse(localStorage.getItem(PREFIX + key)); } catch (e) { return null; }
  }
  function set(key, value) {
    try { localStorage.setItem(PREFIX + key, JSON.stringify(value)); } catch (e) { /* private window etc: pages still work, just without prefill */ }
  }
  function lead() { return get("lead") || {}; }
  function saveLead(update) {
    var current = lead();
    for (var k in update) { if (update[k]) current[k] = update[k]; }
    set("lead", current);
  }

  /* Fill any element with data-cm="firstName|email|mobile|fullName" (text) and any input with data-cm-fill="..." (value). */
  function fill() {
    var l = lead();
    var size = get("size");
    var values = { firstName: l.firstName, email: l.email, mobile: l.mobile, fullName: l.fullName || l.firstName, sizeKnown: size };
    document.querySelectorAll("[data-cm-fill]").forEach(function (el) {
      var v = values[el.getAttribute("data-cm-fill")];
      if (v && !el.value) el.value = v;
    });
    document.querySelectorAll("[data-cm]").forEach(function (el) {
      var v = values[el.getAttribute("data-cm")];
      if (v) el.textContent = v;
    });
    document.querySelectorAll("[data-cm-show-if]").forEach(function (el) {
      el.style.display = values[el.getAttribute("data-cm-show-if")] ? "inline" : "none";
    });
    document.querySelectorAll("[data-cm-hide-if]").forEach(function (el) {
      el.style.display = values[el.getAttribute("data-cm-hide-if")] ? "none" : "";
    });
    if (size) {
      document.querySelectorAll("select[data-cm-size]").forEach(function (sel) { sel.value = size; });
      document.querySelectorAll("[data-cm-size-text]").forEach(function (el) { el.textContent = size; });
    }
  }

  /* ---------- Size finder ---------- */
  /* South African shoe sizes use the UK scale. EU equivalents are approximate. */
  var SHOE = [
    ["3", "EU 35.5"], ["3.5", "EU 36"], ["4", "EU 37"], ["4.5", "EU 37.5"], ["5", "EU 38"], ["5.5", "EU 38.5"],
    ["6", "EU 39"], ["6.5", "EU 40"], ["7", "EU 40.5"], ["7.5", "EU 41"], ["8", "EU 42"], ["8.5", "EU 42.5"],
    ["9", "EU 43"], ["9.5", "EU 44"], ["10", "EU 44.5"], ["10.5", "EU 45"], ["11", "EU 46"], ["11.5", "EU 46.5"],
    ["12", "EU 47"], ["12.5", "EU 47.5"], ["13", "EU 48"], ["13.5", "EU 49 or bigger"]
  ];

  function recommend(shoe, swollen) {
    var s = parseFloat(shoe);
    var size, note = "";
    if (s < 4) { size = "4 to 7"; note = "It's our smallest size, so it may feel a little roomy."; }
    else if (s <= 6.5) { size = "4 to 7"; }
    else if (s <= 7.5) {
      if (swollen) { size = "8 to 12"; note = "Because the feet or ankles swell, the larger size gives more room."; }
      else { size = "4 to 7"; note = s === 7.5 ? "You're at the top of this size. If the feet swell during the day, choose 8 to 12." : ""; }
    }
    else if (s <= 12) { size = "8 to 12"; }
    else { size = "8 to 12"; note = "It's our largest size. The leg stretches, but above size 12 it may feel snug."; }
    return { size: size, note: note };
  }

  function buildFinder() {
    if (document.getElementById("cmSizeFinder")) return;
    var options = SHOE.map(function (r) {
      var label = r[0].replace(".5", "½");
      return '<option value="' + r[0] + '">Size ' + label + " (" + r[1] + ")</option>";
    }).join("");
    var wrap = document.createElement("div");
    wrap.className = "modal-bg";
    wrap.id = "cmSizeFinder";
    wrap.setAttribute("role", "dialog");
    wrap.setAttribute("aria-modal", "true");
    wrap.setAttribute("aria-labelledby", "cmSfTitle");
    wrap.innerHTML =
      '<div class="modal sf">' +
        '<button class="x" type="button" aria-label="Close" data-sf-close>×</button>' +
        '<div class="kicker">Size finder</div>' +
        '<h2 id="cmSfTitle" style="font-size:26px;">Find the right size</h2>' +
        '<p class="muted" style="margin-bottom:18px;">Two quick questions. Buying for someone else? Answer for them.</p>' +
        '<form class="form" style="box-shadow:none; border:0; padding:0; text-align:left;">' +
          '<label for="cmSfShoe">1. What shoe size do they wear?</label>' +
          '<select id="cmSfShoe" required><option value="">Choose a shoe size</option>' + options + "</select>" +
          '<p class="small" style="margin:-8px 0 16px;">South African shoe sizes, the same as UK sizes.</p>' +
          '<label>2. Do the feet or ankles often swell?</label>' +
          '<div class="sf-choice">' +
            '<label><input type="radio" name="cmSfSwell" value="no" checked> No</label>' +
            '<label><input type="radio" name="cmSfSwell" value="yes"> Yes</label>' +
          "</div>" +
          '<button class="btn btn-block" type="submit" style="margin-top:18px;">Show my size</button>' +
        "</form>" +
        '<div class="sf-result" id="cmSfResult" hidden>' +
          '<div class="small" style="margin-bottom:4px;">We recommend</div>' +
          '<div class="sf-size">Size <span id="cmSfSize"></span></div>' +
          '<p id="cmSfNote" class="muted" style="margin:8px 0 0;"></p>' +
          '<p class="small" style="margin:12px 0 16px;">Covered by our Stays-Up Promise: if the size isn\'t right, we\'ll swap it free.</p>' +
          '<button class="btn btn-block" type="button" id="cmSfUse">Use this size</button>' +
        "</div>" +
      "</div>";
    (document.querySelector(".cm-page") || document.body).appendChild(wrap);

    var form = wrap.querySelector("form");
    var chosen = null;
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var shoe = document.getElementById("cmSfShoe").value;
      if (!shoe) { document.getElementById("cmSfShoe").focus(); return; }
      var swollen = wrap.querySelector('input[name="cmSfSwell"]:checked').value === "yes";
      var r = recommend(shoe, swollen);
      chosen = r.size;
      document.getElementById("cmSfSize").textContent = r.size;
      document.getElementById("cmSfNote").textContent = r.note;
      document.getElementById("cmSfNote").style.display = r.note ? "" : "none";
      var res = document.getElementById("cmSfResult");
      res.hidden = false;
      try { res.scrollIntoView({ block: "end", behavior: "smooth" }); } catch (err) { res.scrollIntoView(false); }
    });
    document.getElementById("cmSfUse").addEventListener("click", function () {
      if (chosen) set("size", chosen);
      closeFinder();
      fill();
      var after = wrap.getAttribute("data-after");
      if (after) location.href = after;
    });
    wrap.addEventListener("click", function (e) {
      if (e.target === wrap || e.target.hasAttribute("data-sf-close")) closeFinder();
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeFinder(); });
  }

  function openFinder(afterUrl) {
    buildFinder();
    var wrap = document.getElementById("cmSizeFinder");
    if (afterUrl) wrap.setAttribute("data-after", afterUrl); else wrap.removeAttribute("data-after");
    wrap.classList.add("show");
    setTimeout(function () { document.getElementById("cmSfShoe").focus(); }, 50);
  }
  function closeFinder() {
    var wrap = document.getElementById("cmSizeFinder");
    if (wrap) wrap.classList.remove("show");
  }

  /* Any element with data-size-finder opens the finder. data-size-finder="page.html" goes there after "Use this size". */
  document.addEventListener("click", function (e) {
    var t = e.target.closest ? e.target.closest("[data-size-finder]") : null;
    if (t) { e.preventDefault(); openFinder(t.getAttribute("data-size-finder") || null); }
  });
  if (document.readyState === "loading") { document.addEventListener("DOMContentLoaded", fill); } else { fill(); }

  return { get: get, set: set, lead: lead, saveLead: saveLead, fill: fill, openFinder: openFinder, recommend: recommend };
})();

/* Cape Mohair funnel: what each page does inside Shopify.
   Source file. build-shopify-theme.py joins it to the shared CM object and writes files/cm-funnel-<version>.js.

   Pages, marked by data-cm-page on the wrapper:
     article   the sock-marks article
     guide     the free guide sign-up
     kit       the kit page, with the one-pair pop-up for people who are leaving
     addon     the Lightweight pair, offered between the buy button and the checkout
     second    the second kit, reached from the thank-you page after the first order
     club      the Fresh Feet Club sign-up, reached from the buyer emails
     clubset   the club's three fresh pairs at the member price
     family    the Family Pack: three pairs each for two people
     review    the review form

   Everything the funnel adds to the cart carries the hidden property _cm, so it can be found again
   without touching anything else the shopper may have in their cart.

   v5 (13 Oct 2026, offline until Salem and Cape Mohair say go): the "Only X left" line and the waiting list on the
   kit, second kit, club set and Family Pack pages. Built with `build-shopify-theme.py --stock`. The script that is
   live today is cm-funnel-shopify-v4.js, kept unchanged for the ordinary build. */
(function () {
  var page = document.querySelector(".cm-page[data-cm-page]");
  if (!page) return;
  var kind = page.getAttribute("data-cm-page");
  var PREVIEW = window.CM_PREVIEW || null;               /* set only by the local preview */
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  var CHECKOUT = PREVIEW ? PREVIEW.checkout : ROOT + "checkout";

  /* ---------- tracking: one event name, picked up by Shopify's pixels, Meta and Google ---------- */
  function track(name, data) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data || {}); } catch (e) {}
    if (name === "cm_guide_signup") {
      try { if (window.fbq) fbq("track", "Lead"); } catch (e) {}
      try { if (window.gtag) gtag("event", "generate_lead"); } catch (e) {}
    }
  }

  /* ---------- cart ---------- */
  function req(path, body) {
    var opt = { headers: { "Accept": "application/json" }, credentials: "same-origin" };
    if (body) { opt.method = "POST"; opt.headers["Content-Type"] = "application/json"; opt.body = JSON.stringify(body); }
    return fetch(ROOT + path, opt).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw j; return j; });
    });
  }
  var cart = {
    get: function () { return req("cart.js"); },
    add: function (variantId, tag) { return cart.addAll([variantId], tag); },
    addAll: function (ids, tag) {
      return req("cart/add.js", { items: ids.map(function (id) { return { id: id, quantity: 1, properties: { _cm: tag } }; }) });
    },
    change: function (key, qty) { return req("cart/change.js", { id: key, quantity: qty }); },
    clear: function () { return req("cart/clear.js", {}); }
  };
  function isOurs(item) { return !!(item.properties && item.properties._cm); }
  /* Take out what the funnel put in earlier, so going back and choosing again never doubles the order. */
  function removeOurs(tags) {
    return cart.get().then(function (c) {
      var lines = c.items.filter(function (i) { return isOurs(i) && (!tags || tags.indexOf(i.properties._cm) > -1); });
      return lines.reduce(function (p, line) { return p.then(function () { return cart.change(line.key, 0); }); }, Promise.resolve());
    });
  }

  /* ---------- size and colour choosers ---------- */
  function variants(id) {
    var el = document.getElementById(id);
    try { return (el && JSON.parse(el.textContent)) || []; } catch (e) { return []; }   /* a product that isn't there gives null */
  }
  function selects(attr) { return Array.prototype.slice.call(page.querySelectorAll("select[data-" + attr + "]")); }
  function labelOf(sel) {
    var l = page.querySelector('label[for="' + sel.id + '"]');
    return l ? "a " + l.textContent.trim().toLowerCase() : "an option";
  }
  /* ---------- a kit with one pair of each colour ----------
     Shopify's Bundles allows a sock in a kit only once. So a mixed kit is three single pairs, each a third of the
     kit's price and each tied to the real sock's stock. The page adds the choice to the colour list. */
  var MIX = "__mix";
  var MIX_LABEL = "One of each colour";
  var SIZE = /\d+\s*to\s*\d+/;
  function sizeOf(v) { return (v.options || []).filter(function (o) { return SIZE.test(o); })[0]; }
  /* the pairs in one size, one per colour; null unless every colour is there and in stock */
  function mixFor(mixList, size) {
    var pairs = mixList.filter(function (v) { return sizeOf(v) === size; });
    return pairs.length > 1 && pairs.every(function (v) { return v.available !== false; }) ? pairs : null;
  }
  function mixSizes(mixList) {
    return mixList.map(sizeOf).filter(function (s, i, all) { return s && all.indexOf(s) === i; });
  }
  function offerMix(sels, mixList) {
    if (!mixList.length) return;
    var colour = sels.filter(function (s) { return /colou?r/.test(labelOf(s)); })[0];
    if (!colour || colour.querySelector('option[value="' + MIX + '"]')) return;
    var opt = document.createElement("option");
    opt.value = MIX;
    opt.textContent = MIX_LABEL;
    colour.appendChild(opt);
  }

  function pick(list, sels, mixList) {
    var missing = sels.filter(function (s) { return !s.value; });
    sels.forEach(function (s) { s.classList.toggle("cm-need", !s.value); });
    if (missing.length) return { missing: missing.map(labelOf) };
    var vals = sels.map(function (s) { return s.value; });
    if (vals.indexOf(MIX) > -1) {
      var pairs = mixFor(mixList || [], vals.filter(function (x) { return x !== MIX; })[0]);
      return pairs ? { variant: pairs[0], mix: pairs } : { variant: null };
    }
    var v = list.filter(function (x) { return x.options.every(function (o, i) { return o === vals[i]; }); })[0];
    return { variant: v || null };
  }
  function say(which, text) {
    var el = page.querySelector('[data-cm-msg="' + which + '"]');
    if (!el) return;
    el.textContent = text || "";
    el.hidden = !text;
  }
  function busy(btn, on) { if (btn) btn.setAttribute("aria-busy", on ? "true" : "false"); }
  function problem(which, res) {
    if (res.missing) return "Please choose " + res.missing.join(" and ") + " first.";
    if (!res.variant) return "That combination isn't available. Please choose another.";
    if (res.variant.available === false) return "Sorry, that one is out of stock right now. Please choose another.";
    return "";
  }
  /* Grey out colours that are sold out in the chosen size.
     keep: the page has a waiting list, so a sold-out choice stays choosable (marked "sold out") and opens it. */
  function markSoldOut(list, sels, mixList, keep) {
    mixList = mixList || [];
    function refresh() {
      sels.forEach(function (sel, idx) {
        Array.prototype.forEach.call(sel.options, function (opt) {
          if (!opt.value) return;
          var others = sels.map(function (s, i) { return i === idx ? opt.value : s.value; });
          var soldOut;
          if (others.indexOf(MIX) > -1) {
            /* one of each colour: every colour has to be in stock in that size */
            var size = others.filter(function (o) { return o && o !== MIX; })[0];
            soldOut = size ? !mixFor(mixList, size) : !mixSizes(mixList).some(function (s) { return mixFor(mixList, s); });
          } else {
            var matches = list.filter(function (v) { return v.options.every(function (o, i) { return !others[i] || o === others[i]; }); });
            soldOut = matches.length > 0 && matches.every(function (v) { return v.available === false; });
          }
          opt.disabled = soldOut && !keep;
          opt.textContent = (opt.value === MIX ? MIX_LABEL : opt.value) + (soldOut ? " (sold out)" : "");
          if (soldOut && !keep && sel.value === opt.value) sel.value = "";
        });
      });
    }
    sels.forEach(function (s) { s.addEventListener("change", refresh); });
    refresh();
  }
  page.addEventListener("change", function (e) {
    if (e.target.matches && e.target.matches(".cm-choose select")) e.target.classList.remove("cm-need");
  });

  function money(cents) {
    var rand = cents / 100;
    var whole = Math.round(rand) === rand;
    return "R" + rand.toLocaleString("en-ZA", { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 }).replace(/\s/g, " ");
  }
  function withParam(url, query) { return url + (url.indexOf("?") > -1 ? "&" : "?") + query; }
  function fail(which, btn) {
    return function () {
      busy(btn, false);
      say(which, "Something went wrong adding that to your order. Please try again.");
    };
  }

  /* ---------- stock: "Only X left" and the waiting list (added in v5) ----------
     #cmStock holds the Diabetic sock's pairs in stock by colour and size ("Navy / 8 to 12"), or null where Shopify
     doesn't count them, and "low": at or below this many kits (or sets, or pairs) the page says how many are left.
     Every offer is made of that sock, so its kits, sets and pairs carry the same titles.
     A page without #cmStock or without a waiting-list box works as before: sold-out choices are greyed out. */
  var STOCK = (function () {
    var el = document.getElementById("cmStock");
    try { var s = el && JSON.parse(el.textContent); return s && s.pairs ? s : null; } catch (e) { return null; }
  })();
  function hasWaitlist(which) { return !!(STOCK && page.querySelector('[data-cm-wait="' + which + '"]')); }
  function pairsOf(title) { var p = STOCK && STOCK.pairs[title]; return typeof p === "number" ? p : null; }
  function colourOf(v) { return (v.options || []).filter(function (o) { return !SIZE.test(o); })[0]; }
  function allOut(list, mixList) {
    mixList = mixList || [];
    return list.length > 0 && list.every(function (v) { return v.available === false; }) &&
           !mixSizes(mixList).some(function (s) { return mixFor(mixList, s); });
  }
  /* What one set of choosers holds: nothing yet (open), sold out (out), or in stock with how many are left. */
  function chosen(list, sels, mixList, per) {
    var vals = sels.map(function (s) { return s.value; });
    if (vals.some(function (v) { return !v; })) return { open: true };
    if (vals.indexOf(MIX) > -1) {
      var size = vals.filter(function (x) { return x !== MIX; })[0];
      var pairs = mixFor(mixList || [], size);
      var mixLabel = "one of each colour, size " + size;
      if (!pairs) return { out: true, label: mixLabel, choice: "Any colour, size " + size };
      var counts = pairs.map(function (v) { return pairsOf(v.title); });
      /* a mixed kit takes one pair of each colour */
      return { label: mixLabel, left: counts.some(function (n) { return n === null; }) ? null : Math.min.apply(null, counts) };
    }
    var v = list.filter(function (x) { return x.options.every(function (o, i) { return o === vals[i]; }); })[0];
    if (!v) return { open: true };
    var label = colourOf(v) + ", size " + sizeOf(v);
    if (v.available === false) return { out: true, label: label, choice: label };
    var p = pairsOf(v.title);
    return { label: label, title: v.title, left: p === null ? null : Math.floor(p / per) };
  }
  /* The tag Shopify's own sign-up form gives, the same one Flow makes from the Forms answer:
     "Navy, size 8 to 12" -> cm-wait-navy-8-to-12, "Any colour, size 4 to 7" -> cm-wait-any-colour-4-to-7 */
  function waitTag(choice) {
    return "cm-wait-" + choice.toLowerCase().replace("size ", "").replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
  }
  /* Pick the same colour and size in the waiting-list form's own list, where the form lets the page reach it. */
  function preselect(root, choice) {
    if (!choice) return;
    var lists = Array.prototype.slice.call(root.querySelectorAll("select"));
    Array.prototype.forEach.call(root.querySelectorAll("*"), function (el) {
      if (el.shadowRoot) lists = lists.concat(Array.prototype.slice.call(el.shadowRoot.querySelectorAll("select")));
    });
    lists.forEach(function (sel) {
      Array.prototype.forEach.call(sel.options, function (o) {
        if (o.textContent.trim().toLowerCase() !== choice.toLowerCase() || sel.value === o.value) return;
        sel.value = o.value;
        sel.dispatchEvent(new Event("change", { bubbles: true }));
      });
    });
  }
  /* Watch the choosers of one offer.
     which   the name in data-cm-buy, data-cm-stock and data-cm-wait
     people  a list of choosers per person: one, or two for the Family Pack
     per     pairs of the sock in one of what is sold (3 for a kit or a set)
     unit    what one is called on the page ("kit", "set") */
  function watchStock(which, list, people, mixList, per, unit) {
    if (!hasWaitlist(which)) return null;
    var box = page.querySelector('[data-cm-wait="' + which + '"]');
    var line = page.querySelector('[data-cm-stock="' + which + '"]');
    var title = box.querySelector("[data-cm-wait-title]");
    var tags = box.querySelector("[data-cm-wait-tags]");
    var ask = box.querySelector("[data-cm-wait-ask]");
    var done = box.querySelector("[data-cm-wait-done]");
    /* the buy button next to the box; the kit page's other buttons only lead down to it */
    var buttons = Array.prototype.filter.call(box.parentNode.children, function (el) {
      return el.getAttribute("data-cm-buy") === which;
    });
    var current = null;
    var waitParam = new URLSearchParams(location.search).get("waitlist");
    /* ?waitlist=test keeps the box open while everything is in stock, to test the sign-up form in the store */
    var testing = waitParam === "test";
    function refresh() {
      var states = people.map(function (sels) { return chosen(list, sels, mixList, per); });
      /* two sets of the same colour and size take twice the pairs */
      if (states.length === 2 && states[0].title && states[0].title === states[1].title && states[0].left !== null && states[0].left < 2) {
        states[1] = { out: true, label: states[1].label, choice: states[1].label, head: "Only one set of " + states[1].label + " is left" };
      }
      var out = states.filter(function (s) { return s.out; })[0] || null;
      if (!out && allOut(list, mixList)) out = { out: true, label: null, choice: null };
      current = out;
      box.hidden = !out && !testing;
      buttons.forEach(function (b) { b.style.display = out ? "none" : ""; });
      if (out) {
        title.textContent = out.head ||
          (out.label ? out.label.charAt(0).toUpperCase() + out.label.slice(1) + " is sold out for now" : "Sold out for now");
        if (tags) tags.value = "cm-waitlist" + (out.choice ? "," + waitTag(out.choice) : "");
        preselect(box, out.choice);
      }
      var low = out ? null : states.filter(function (s) { return typeof s.left === "number" && s.left > 0 && s.left <= STOCK.low; })[0];
      if (line) {
        line.hidden = !low;
        line.textContent = low ? "Only " + low.left + " " + unit + (low.left === 1 ? "" : "s") + " left in " + low.label + "." : "";
      }
    }
    /* a new choice after signing up asks again, for that colour and size */
    function changed() { ask.hidden = false; done.hidden = true; refresh(); }
    people.forEach(function (sels) { sels.forEach(function (s) { s.addEventListener("change", changed); }); });
    function thanks() {
      box.hidden = false;
      ask.hidden = true;
      done.hidden = false;
      track("cm_waitlist_signup");
    }
    if (waitParam === "1") {
      /* back from Shopify's own sign-up form, which returns the visitor here with ?waitlist=1 */
      thanks();
      setTimeout(function () { box.scrollIntoView({ block: "center" }); }, 0);
    } else {
      refresh();
      if (testing) setTimeout(function () { box.scrollIntoView({ block: "center" }); }, 0);
    }
    var form = box.querySelector("form.cm-wait-form");
    if (form) form.addEventListener("submit", function (e) {
      var name = form.querySelector('[name$="first_name]"], [name="first_name"]');
      var email = form.querySelector('[type="email"]');
      var first = name ? (name.value || "").trim() : "";
      CM.saveLead({ firstName: first.split(" ")[0], fullName: first, email: email ? email.value.trim() : "" });
      CM.fill();
      if (!PREVIEW) return;                 /* Shopify saves the contact as an email subscriber, with the tags above */
      e.preventDefault();
      thanks();
    });
    return {
      /* true while the choice is sold out: the box is showing and nothing may be ordered */
      out: function () { refresh(); return !!current; },
      show: function () { box.scrollIntoView({ block: "center" }); track("cm_waitlist_view"); }
    };
  }

  /* =====================================================================  ARTICLE  */
  if (kind === "article") {
    track("cm_article_view");
  }

  /* =====================================================================  GUIDE SIGN-UP  */
  if (kind === "guide") {
    var guideKit = page.getAttribute("data-kit-url");
    /* The form sends the visitor straight to the kit page once Shopify has saved the contact (its return_to).
       If Shopify brings them back here instead, for example when it refuses the address, pass them on. */
    var posted = page.querySelector("[data-cm-posted]");
    if (posted) {
      var refused = posted.hasAttribute("data-cm-form-error");
      if (refused) { try { sessionStorage.removeItem("cm_signup"); } catch (err) {} }
      location.replace(withParam(guideKit, refused ? "from=optin&guide=page" : "from=optin"));
      return;
    }
    var form = document.getElementById("cmGuideForm");
    if (form) form.addEventListener("submit", function (e) {
      var first = (form.querySelector('[name="contact[first_name]"]').value || "").trim();
      var email = (form.querySelector('[name="contact[email]"]').value || "").trim();
      CM.saveLead({ firstName: first.split(" ")[0], fullName: first, email: email });
      var consent = document.getElementById("cmConsentEmail").checked;
      /* a sign-up with the tick is counted on the kit page, once the visitor has arrived there */
      if (consent) { try { sessionStorage.setItem("cm_signup", "1"); } catch (err) {} }
      if (consent && !PREVIEW) return;      /* Shopify saves the contact as an email subscriber, tagged guide-lead */
      /* No tick: nothing is sent to the store. The guide opens on the next page instead. */
      e.preventDefault();
      location.href = withParam(guideKit, consent ? "from=optin" : "from=optin&guide=page");
    });
  }

  /* =====================================================================  KIT PAGE  */
  if (kind === "kit") {
    var addonUrl = page.getAttribute("data-addon-url");
    var q = new URLSearchParams(location.search);
    if (q.get("from") === "optin") {
      var bar = document.getElementById(q.get("guide") === "page" ? "optinDonePage" : "optinDone");
      if (bar) bar.classList.add("show");
      try {
        if (sessionStorage.getItem("cm_signup") === "1") {
          sessionStorage.removeItem("cm_signup");
          if (q.get("guide") !== "page") track("cm_guide_signup");
        }
      } catch (err) {}
    }
    /* Has this visitor asked for the guide, now or on an earlier visit? If not, the page doesn't talk as if they had. */
    var knowsGuide = q.get("from") === "optin" || !!(CM.lead().email || CM.lead().firstName);
    page.setAttribute("data-cm-visitor", knowsGuide ? "guide" : "new");
    var kitMix = variants("cmKitMixVariants");
    offerMix(selects("cm-kit-opt"), kitMix);
    markSoldOut(variants("cmKitVariants"), selects("cm-kit-opt"), kitMix, hasWaitlist("kit"));
    markSoldOut(variants("cmSingleVariants"), selects("cm-single-opt"));
    var kitWatch = watchStock("kit", variants("cmKitVariants"), [selects("cm-kit-opt")], kitMix, 3, "kit");
    track("cm_kit_view");

    /* the one-pair pop-up; when the sock is sold out everywhere there is no pair to offer */
    var pop = document.getElementById("exitPop");
    if (STOCK && allOut(variants("cmSingleVariants"))) pop = null;
    var clickedBuy = false;
    function seen() { try { return sessionStorage.getItem("cm_exit_seen") === "1"; } catch (e) { return false; } }
    function showExit(force) {
      if (!pop || (!force && (seen() || clickedBuy))) return;
      pop.classList.add("show");
      try { sessionStorage.setItem("cm_exit_seen", "1"); } catch (e) {}
    }
    function hideExit() { if (pop) pop.classList.remove("show"); }
    /* a mouse leaving through the top of the window; phones can't show that, so they get a timer */
    document.addEventListener("mouseout", function (e) { if (!e.relatedTarget && e.clientY <= 0) showExit(false); });
    if (window.matchMedia && window.matchMedia("(hover: none)").matches) setTimeout(function () { showExit(false); }, 60000);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") hideExit(); });
    if (pop) pop.addEventListener("click", function (e) { if (e.target === pop) hideExit(); });

    page.addEventListener("click", function (e) {
      if (!e.target.closest) return;
      var buyBtn = e.target.closest("[data-cm-buy]");
      if (buyBtn) { e.preventDefault(); buy(buyBtn.getAttribute("data-cm-buy"), buyBtn); return; }
      if (e.target.closest("[data-cm-open-single]")) {
        e.preventDefault();
        if (pop) showExit(true); else if (kitWatch) { kitWatch.out(); kitWatch.show(); }
        return;
      }
      if (e.target.closest("[data-cm-close-exit]")) { e.preventDefault(); hideExit(); }
    });

    function buy(which, btn) {
      var isKit = which === "kit";
      /* sold out: the waiting list instead of an order */
      if (isKit && kitWatch && kitWatch.out()) { kitWatch.show(); return; }
      var res = pick(variants(isKit ? "cmKitVariants" : "cmSingleVariants"), selects(isKit ? "cm-kit-opt" : "cm-single-opt"),
                     isKit ? kitMix : null);
      var msg = problem(which, res);
      if (msg) {
        say(which, msg);
        if (isKit) { var at = document.getElementById("cm-order"); if (at) at.scrollIntoView({ block: "center" }); }
        return;
      }
      say(which, "");
      busy(btn, true);
      clickedBuy = true;
      /* remember the size they chose, so the add-on page starts from it */
      var chosenSize = page.querySelector("select[data-cm-" + (isKit ? "kit" : "single") + "-opt][data-cm-size]");
      if (chosenSize && chosenSize.value) CM.set("size", chosenSize.value);
      removeOurs(null)
        .then(function () {
          if (res.mix) return cart.addAll(res.mix.map(function (v) { return v.id; }), "kit");
          return cart.add(res.variant.id, isKit ? "kit" : "single");
        })
        .then(function () { track(isKit ? "cm_kit_chosen" : "cm_single_chosen"); location.href = addonUrl; })
        .catch(fail(which, btn));
    }
  }

  /* =====================================================================  ADD-ON PAGE  */
  if (kind === "addon") {
    var kitUrl = page.getAttribute("data-kit-url");
    var lwList = variants("cmLwVariants");
    var lwSels = selects("cm-lw-opt");
    var linesBox = document.getElementById("cmOrderLines");
    var haveOrder = false;

    function renderOrder(c) {
      var items = c.items || [];
      haveOrder = items.length > 0;
      if (!haveOrder) {
        linesBox.innerHTML = '<p style="margin:0;">Your order is empty. <a href="' + kitUrl + '">Choose your kit</a> first.</p>';
        return;
      }
      /* a kit with one pair of each colour is three lines in the cart; show it as the one kit it is */
      ["kit", "second"].forEach(function (tag) {
        var pairs = items.filter(function (i) { return i.properties && i.properties._cm === tag; });
        if (pairs.length < 2) return;
        var colours = pairs.map(function (i) {
          return (i.variant_options || []).filter(function (o) { return !SIZE.test(o); })[0];
        }).filter(Boolean);
        var one = {
          image: pairs[0].image, product_title: pairs[0].product_title.split(",")[0], quantity: 1, properties: pairs[0].properties,
          variant_options: pairs[0].variant_options,
          variant_title: "One pair each: " + colours.join(", ") + " / " + (sizeOf({ options: pairs[0].variant_options }) || ""),
          final_line_price: pairs.reduce(function (sum, i) { return sum + i.final_line_price; }, 0)
        };
        items = [one].concat(items.filter(function (i) { return pairs.indexOf(i) === -1; }));
      });
      var html = items.map(function (i) {
        var img = i.image ? '<img src="' + i.image + '" alt="">' : "<span></span>";
        var opts = i.variant_title && i.variant_title !== "Default Title" ? '<br><span class="muted">' + i.variant_title + "</span>" : "";
        return '<div class="cm-line-item">' + img + "<div><b>" + i.product_title + "</b>" + opts + "</div></div>" +
               '<div class="line"><span>' + i.quantity + " × " + i.product_title + "</span><span>" + money(i.final_line_price) + "</span></div>";
      }).join("");
      html += '<div class="line"><span>Delivery</span><span>' + (c.total_price >= 50000 ? "Free" : "Added at checkout") + "</span></div>";
      html += '<div class="line total"><span>Total</span><span>' + money(c.total_price) + "</span></div>";
      linesBox.innerHTML = html;
      /* start the add-on at the same size as the pair or kit they chose */
      var main = items.filter(isOurs)[0] || items[0];
      var sizeSel = page.querySelector("select[data-cm-lw-opt][data-cm-size]");
      if (main && sizeSel) {
        var size = (main.variant_options || []).filter(function (o) { return /\d+\s*to\s*\d+/.test(o); })[0];
        if (size) {
          Array.prototype.forEach.call(sizeSel.options, function (o) { if (o.value === size) sizeSel.value = size; });
          sizeSel.dispatchEvent(new Event("change"));
        }
      }
    }

    markSoldOut(lwList, lwSels);
    removeOurs(["addon"]).then(cart.get).then(renderOrder).catch(function () {
      linesBox.innerHTML = '<p class="muted" style="margin:0;">We couldn\'t load your order. You can still continue to checkout.</p>';
      haveOrder = true;
    });
    track("cm_addon_view");

    page.addEventListener("click", function (e) {
      var t = e.target.closest ? e.target.closest("[data-cm-addon]") : null;
      if (!t) return;
      e.preventDefault();
      if (!haveOrder) { location.href = kitUrl; return; }
      if (t.getAttribute("data-cm-addon") === "no") { track("cm_addon_no"); location.href = CHECKOUT; return; }
      var res = pick(lwList, lwSels);
      var msg = problem("lw", res);
      if (msg) { say("lw", msg); return; }
      say("lw", "");
      busy(t, true);
      cart.add(res.variant.id, "addon")
        .then(function () { track("cm_addon_yes"); location.href = CHECKOUT; })
        .catch(fail("lw", t));
    });
  }

  /* ---------- one product, then straight to Shopify's checkout ----------
     The second kit and the club's fresh pairs work the same way: colour, size, checkout.
     which     the name in data-cm-buy and data-cm-msg
     opt       the choosers' attribute, without "data-"
     list, mix the ids of the two variant lists
     ownSize   true when the socks are for the buyer, so the chooser starts from the size they chose before
     unit      what one is called in the "Only X left" line ("kit", "set") */
  function straightToCheckout(o) {
    var sels = selects(o.opt);
    var list = variants(o.list);
    var mix = variants(o.mix);
    if (!o.ownSize) {
      /* It's for someone else, so don't start from the buyer's own size. The size finder can still fill it in. */
      var sizeSel = page.querySelector("select[data-" + o.opt + "][data-cm-size]");
      if (sizeSel) sizeSel.removeAttribute("data-cm-size");
      sels.forEach(function (s) { s.value = ""; });
      document.addEventListener("click", function (e) {
        if (!e.target || e.target.id !== "cmSfUse") return;
        setTimeout(function () {
          var found = CM.get("size");
          if (found && sizeSel) { sizeSel.value = found; sizeSel.dispatchEvent(new Event("change", { bubbles: true })); }
        }, 0);
      });
    }
    offerMix(sels, mix);
    markSoldOut(list, sels, mix, hasWaitlist(o.which));
    var watch = watchStock(o.which, list, [sels], mix, 3, o.unit);
    track("cm_" + o.which + "_view");
    page.addEventListener("click", function (e) {
      var t = e.target.closest ? e.target.closest('[data-cm-buy="' + o.which + '"]') : null;
      if (!t) return;
      e.preventDefault();
      if (watch && watch.out()) { watch.show(); return; }
      var res = pick(list, sels, mix);
      var msg = problem(o.which, res);
      if (msg) { say(o.which, msg); return; }
      say(o.which, "");
      busy(t, true);
      cart.clear()
        .then(function () {
          if (res.mix) return cart.addAll(res.mix.map(function (v) { return v.id; }), o.which);
          return cart.add(res.variant.id, o.which);
        })
        .then(function () { track("cm_" + o.which + "_yes"); location.href = CHECKOUT; })
        .catch(fail(o.which, t));
    });
  }

  /* =====================================================================  SECOND KIT  */
  if (kind === "second") {
    straightToCheckout({ which: "second", opt: "cm-second-opt", list: "cmSecondVariants", mix: "cmSecondMixVariants", ownSize: false, unit: "kit" });
  }

  /* =====================================================================  FRESH FEET CLUB: JOINING  */
  if (kind === "club") {
    var clubSet = page.getAttribute("data-clubset-url");
    /* The form sends the new member straight to the fresh pairs (its return_to).
       If Shopify brings them back here instead, pass them on. */
    if (page.querySelector("[data-cm-posted]")) {
      location.replace(withParam(clubSet, "from=club"));
      return;
    }
    var clubForm = document.getElementById("cmClubForm");
    if (clubForm) clubForm.addEventListener("submit", function (e) {
      var first = (clubForm.querySelector('[name="contact[first_name]"]').value || "").trim();
      var email = (clubForm.querySelector('[name="contact[email]"]').value || "").trim();
      CM.saveLead({ firstName: first.split(" ")[0], fullName: first, email: email });
      try { sessionStorage.setItem("cm_club_joined", "1"); } catch (err) {}
      if (!PREVIEW) return;                 /* Shopify saves the contact as an email subscriber, tagged club-member */
      e.preventDefault();
      location.href = withParam(clubSet, "from=club");
    });
    track("cm_club_view");
  }

  /* =====================================================================  FRESH FEET CLUB: THE FRESH PAIRS  */
  if (kind === "clubset") {
    if (new URLSearchParams(location.search).get("from") === "club") {
      var joined = document.getElementById("clubDone");
      if (joined) joined.classList.add("show");
      try {
        if (sessionStorage.getItem("cm_club_joined") === "1") {
          sessionStorage.removeItem("cm_club_joined");
          track("cm_club_joined");
        }
      } catch (err) {}
    }
    straightToCheckout({ which: "clubset", opt: "cm-club-opt", list: "cmClubVariants", mix: "cmClubMixVariants", ownSize: true, unit: "set" });
  }

  /* =====================================================================  FAMILY PACK  */
  /* Shopify's Bundles allows a sock in a pack only once. So the Family Pack is two sets of three pairs,
     one for each person, each half the pack's price and each with its own colour and size. */
  if (kind === "family") {
    var famList = variants("cmFamilyVariants");
    var people = [selects("cm-fam1-opt"), selects("cm-fam2-opt")];
    var famSizes = people.map(function (sels) {
      return sels.filter(function (s) { return s.hasAttribute("data-cm-size"); })[0] || null;
    });
    /* each person has their own size, so the shared size filling is switched off here */
    famSizes.forEach(function (s) { if (s) s.removeAttribute("data-cm-size"); });
    people.forEach(function (sels) { sels.forEach(function (s) { s.value = ""; }); });
    var finderFor = 0;
    document.addEventListener("click", function (e) {
      var opener = e.target.closest ? e.target.closest("[data-cm-for]") : null;
      if (opener) { finderFor = parseInt(opener.getAttribute("data-cm-for"), 10) - 1; return; }
      if (!e.target || e.target.id !== "cmSfUse") return;
      setTimeout(function () {
        var found = CM.get("size");
        var sel = famSizes[finderFor];
        if (found && sel) { sel.value = found; sel.dispatchEvent(new Event("change", { bubbles: true })); }
      }, 0);
    });
    people.forEach(function (sels) { markSoldOut(famList, sels, null, hasWaitlist("family")); });
    var famWatch = watchStock("family", famList, people, null, 3, "set");
    track("cm_family_view");
    page.addEventListener("click", function (e) {
      var t = e.target.closest ? e.target.closest('[data-cm-buy="family"]') : null;
      if (!t) return;
      e.preventDefault();
      if (famWatch && famWatch.out()) { famWatch.show(); return; }
      var picks = people.map(function (sels) { return pick(famList, sels); });
      var msg = problem("family", picks[0]) || problem("family", picks[1]);
      if (msg) { say("family", msg); return; }
      say("family", "");
      busy(t, true);
      cart.clear()
        .then(function () { return cart.addAll(picks.map(function (p) { return p.variant.id; }), "family"); })
        .then(function () { track("cm_family_yes"); location.href = CHECKOUT; })
        .catch(fail("family", t));
    });
  }

  /* =====================================================================  REVIEW  */
  if (kind === "review") {
    track(page.querySelector("[data-cm-posted]") ? "cm_review_sent" : "cm_review_view");
  }
})();
